import React from "react";
import { Button, Card, Table, Tag } from "antd";
import { useNavigate } from "react-router-dom";
import useTrainingGroup from "PlatForms/OrgLMS/Hooks/AdminHooks/useTraining";

const TrainingsList = () => {
  const { loadingGroups, groupData, groupsPagination, handleGroupsPageChange } = useTrainingGroup();
  const navigate = useNavigate();

  const columns = [
    {
      title: "Group Name",
      dataIndex: "groupName",
      key: "groupName",
    },
    {
      title: "Mentor Name",
      dataIndex: "mentorName",
      key: "mentorName",
      render: (text) => (text ? text : "N/A"),
    },
    {
      title: "Created On",
      dataIndex: "createdOn",
      key: "createdOn",
      render: (text) => new Date(text).toLocaleString(),
    },
    {
      title: "Members Count",
      dataIndex: "membersCount",
      key: "membersCount",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        let color = status === 0 ? "gold" : status === 1 ? "green" : "default";
        let text = status === 0 ? "In Progress" : status === 1 ? "Complete" : "Unknown";

        return <Tag color={color}>{text}</Tag>;
      },
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Button type="link" onClick={() => navigate(`/training-detail/${record.id}`)}>
          View Detail
        </Button>
      ),
    },
  ];

  return (
    <Card
      title="Created Groups List"
      className="card-professional"
      extra={
        <Button type="default" onClick={() => navigate("/trainings")}>
          Back
        </Button>
      }
    >
      <>
        <Table
          loading={loadingGroups}
          columns={columns}
          dataSource={groupData}
          rowKey="id"
          scroll={{ x: "max-content" }}
          pagination={{
            current: groupsPagination.pageNumber,
            pageSize: groupsPagination.pageSize,
            total: groupsPagination.totalCount,
            onChange: handleGroupsPageChange,
            showSizeChanger: false,
          }}
        />
      </>
    </Card>
  );
};

export default TrainingsList;
